import TooltipContainer from './ColorTooltip.styles';
import { useTranslation } from '@CS/hooks';
import content from './content';

export const ColorTooltip = () => {
  const tooltip = useTranslation(content);
  return <TooltipContainer>{tooltip}</TooltipContainer>;
};
